import { createApi } from "@reduxjs/toolkit/query/react";

import { IChemicalSearchModelResult } from "../../data/ChemicalSearchModelResult";
import { ISavedSearchModelResult } from "../../data/SavedSearchModelResult";
import type { ChemicalSearchRequest } from "../../data/models/schemas";
import { refreshLicenseInfoMeta } from "../utils/meteringMeta";
import { baseQuery } from "./baseQuery";

export const pocketbookSearchApi = createApi({
    reducerPath: "pocketbookSearchApi",
    baseQuery,
    endpoints: (builder) => ({
        searchChemicals: builder.mutation<
            IChemicalSearchModelResult,
            ChemicalSearchRequest
        >({
            query: (body) => ({
                path: "chemicals/search",
                method: "POST",
                body,
                queryRefreshMeta: refreshLicenseInfoMeta,
            }),
        }),
        listSavedSearches: builder.query<ISavedSearchModelResult[], void>({
            query: () => ({
                path: "listSearches",
                method: "POST",
            }),
            keepUnusedDataFor: 60,
        }),
    }),
});

export const { useSearchChemicalsMutation, useLazyListSavedSearchesQuery } =
    pocketbookSearchApi;
